export enum AbsenceUnit {
  DAYS = 0,
  HOURS = 1,
}
